import { Avatar, Box, Card, CardContent, Grid, Typography } from '@material-ui/core'

function SimpleDashCard({title, titleValue, icon, iconColor, subTitleValue, subTitle, subIcon, width}) {
    return (
        <Card style={{ height: '100%' }}>
            <CardContent>
                <Grid container spacing={1} style={{ justifyContent: 'space-between' }}>
                    <Grid item>
                        <Typography color="textSecondary" gutterBottom variant="h6">
                            {title}
                        </Typography>
                        <Typography color="textPrimary" variant="h3">
                            {titleValue}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Avatar 
                            style={{
                                bgcolor: iconColor,
                                height: width == 'xl' ? 56 : 40,
                                width: width == 'xl' ? 56 : 40,
                            }}
                        >
                            {icon}
                        </Avatar>
                    </Grid>
                </Grid>
                <Box style={{ pt: 1, display: 'flex', alignItems: 'center' }}>
                    {subIcon}
                    <Typography style={{ color: iconColor, mr: 1 }} variant="h6" style={{marginLeft: 5}}>
                        {subTitleValue}
                    </Typography>
                    <Typography color="textSecondary" variant="caption" style={{marginLeft: 5, paddingTop: 3}}>
                        {subTitle}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    )
}

export default SimpleDashCard
